import { Injectable } from '@angular/core';

const STORAGE_KEY = 'cogitationes_admin_token';

/**
 * Admin auth is separate from user auth. Stored in sessionStorage so it does not
 * persist across browser restarts and does not conflict with user login.
 */
@Injectable({ providedIn: 'root' })
export class AdminAuthService {
  private token: string | null = null;

  getToken(): string | null {
    if (this.token != null) return this.token;
    try {
      this.token = sessionStorage.getItem(STORAGE_KEY);
      return this.token;
    } catch {
      return null;
    }
  }

  setToken(token: string): void {
    this.token = token;
    try {
      sessionStorage.setItem(STORAGE_KEY, token);
    } catch {
      // ignore
    }
  }

  clearToken(): void {
    this.token = null;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }

  isAdminLoggedIn(): boolean {
    return !!this.getToken();
  }
}
